export const RENDER_NONCONVERSATIONAL_FILTER =
	"RENDER_NONCONVERSATIONAL_FILTER";
export const UPDATE_FILTER = "UPDATE_FILTER";
